import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { API_URL } from '@core/config/api-url.token';
import { API_ENDPOINTS } from '@shared/constants/api-endpoints.const';
import { TokenResponseDto } from '@features/shared/auth/data/dtos/auth.dto';
import { DeveloperOrganizationDto, SwitchDeveloperOrganizationRequestDto } from '../../dtos/developer-context.dto';

@Injectable()
export class DeveloperContextRemoteDatasource {
  private readonly http = inject(HttpClient);
  private readonly apiUrl = inject(API_URL);

  public listOrganizations(): Observable<readonly DeveloperOrganizationDto[]> {
    return this.http.get<readonly DeveloperOrganizationDto[]>(
      `${this.apiUrl}${API_ENDPOINTS.organizations.list}`,
    );
  }

  public switchOrganization(
    organizationId: number,
    departmentId: number | null,
    refreshToken: string,
  ): Observable<TokenResponseDto> {
    const request: SwitchDeveloperOrganizationRequestDto = {
      OrganizationId: organizationId,
      DepartmentId: departmentId,
      RefreshToken: refreshToken,
    };
    return this.http.post<TokenResponseDto>(
      `${this.apiUrl}${API_ENDPOINTS.auth.developer.switchOrganization}`,
      request,
    );
  }
}
